<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <f7-page name="index">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>
        <!-- 若是有分店則套用 navbar-center，否則就顯示分店名稱 -->
        <navbar-center :title="storeName" :subtitle="storeBranch" v-if="storeBranch" />
        <p v-else>{{ storeName }}</p>
      </f7-nav-title>
    </f7-navbar>
    <f7-block style="">
      <div style="display: flex;">
        <f7-button
          raised
          fill
          style="display: flex; justify-content: center; margin-left: auto;"
          :href="`/stores/${storeIdProp}/hot-sale-search`">
          銷售排行
        </f7-button>
        <f7-button
          raised
          fill
          style="display: flex; justify-content: center; margin-left: 20px;"
          :href="`/stores/${storeIdProp}/statistics-search`">
          業績報表
        </f7-button>
      </div>
    </f7-block>

    <template v-if="todayStatistics">
      <f7-block-title>今天</f7-block-title>
      <f7-card>
        <f7-card-content :padding="false">
          <f7-list v-for="(interval, index) in Object.keys(todayStatistics).sort().map(k => todayStatistics[k])" :key="`todayStatistics-${index}`">
            <f7-list-item :title="interval.interval[0] === 'others' ? '其他' : `${moment(interval.interval[0]).format('YYYY-MM-DD HH:mm')} ~ ${moment(interval.interval[1]).format('YYYY-MM-DD HH:mm')}`" group-title />
            <f7-list-item title="訂單數" :after="interval.order.paid.total || '0'" />
            <f7-list-item title="退款訂單數" :after="interval.order.refunded.total || '0'" />
            <f7-list-item title="來客數" :after="interval.product.paid.total || '0'" />
            <f7-list-item title="平均客單價" :after="parseFloat((interval.total.paid.total / interval.product.paid.total).toFixed(0))" />
            <template>
              <f7-list-item
                v-for="(amount, paymentMethod) in interval.total.paid"
                v-if="paymentMethod !== 'total'"
                :key="`todayStatistics-${index}-total-paid-${paymentMethod}`"
                :title="$t(`paymentMethodType.${paymentMethod}`)" :after="`${interval.total.paid[paymentMethod]} (${parseFloat((interval.total.paid[paymentMethod] / interval.total.paid.total * 100).toFixed(1))}%)`" />
            </template>
            <f7-list-item title="總計" :after="interval.total.paid.total" />
          </f7-list>
        </f7-card-content>
      </f7-card>
    </template>

    <template v-if="yesterdayStatisticsData">
      <f7-block-title>昨天</f7-block-title>
      <f7-card>
        <f7-card-content :padding="false">
          <f7-list>
            <f7-list-item title="訂單數" :after="yesterdayStatisticsData.order.paid.total || '0'" />
            <f7-list-item title="退款訂單數" :after="yesterdayStatisticsData.order.refunded.total || '0'" />
            <f7-list-item title="來客數" :after="yesterdayStatisticsData.product.paid.total || '0'" />
            <f7-list-item title="平均客單價" :after="parseFloat((yesterdayStatisticsData.total.paid.total / yesterdayStatisticsData.product.paid.total).toFixed(0))" />
            <template>
              <f7-list-item
                v-for="(amount, paymentMethod) in yesterdayStatisticsData.total.paid"
                v-if="paymentMethod !== 'total'"
                :key="`yesterdayStatistics-total-paid-${paymentMethod}`"
                :title="$t(`paymentMethodType.${paymentMethod}`)" :after="`${yesterdayStatisticsData.total.paid[paymentMethod]} (${parseFloat((yesterdayStatisticsData.total.paid[paymentMethod] / yesterdayStatisticsData.total.paid.total * 100).toFixed(1))}%)`" />
            </template>
            <f7-list-item title="總計" :after="yesterdayStatisticsData.total.paid.total || '0'" />
          </f7-list>
        </f7-card-content>
      </f7-card>
    </template>

    <template v-if="lastWeekStatisticsData">
      <f7-block-title>{{ lastWeekStatisticsData.interval.length === 0 ? '其他' : `${moment(lastWeekStatisticsData.interval[0]).format('YYYY-MM-DD')} ~ ${moment(lastWeekStatisticsData.interval[1]).format('YYYY-MM-DD')}` }}</f7-block-title>
      <f7-card>
        <f7-card-content :padding="false">
          <f7-list>
            <f7-list-item title="訂單數" :after="lastWeekStatisticsData.order.paid.total || '0'" />
            <f7-list-item title="退款訂單數" :after="lastWeekStatisticsData.order.refunded.total || '0'" />
            <f7-list-item title="來客數" :after="lastWeekStatisticsData.product.paid.total || '0'" />
            <f7-list-item title="平均客單價" :after="parseFloat((lastWeekStatisticsData.total.paid.total / lastWeekStatisticsData.product.paid.total).toFixed(0))" />
            <template>
              <f7-list-item
                v-for="(amount, paymentMethod) in lastWeekStatisticsData.total.paid"
                v-if="paymentMethod !== 'total'"
                :key="`yesterdayStatistics-total-paid-${paymentMethod}`"
                :title="$t(`paymentMethodType.${paymentMethod}`)" :after="`${lastWeekStatisticsData.total.paid[paymentMethod]} (${parseFloat((lastWeekStatisticsData.total.paid[paymentMethod] / lastWeekStatisticsData.total.paid.total * 100).toFixed(1))}%)`" />
            </template>
            <f7-list-item title="總計" :after="lastWeekStatisticsData.total.paid.total || '0'" />
          </f7-list>
        </f7-card-content>
      </f7-card>
    </template>

    <template v-if="storeHotSale">
      <f7-card>
        <f7-card-content :padding="false">
          <f7-list>
            <f7-list-item :title="`${storeHotSale.startDateString} ~ ${storeHotSale.endDateString}`" group-title></f7-list-item>
            <f7-list-item
              v-for="(item, index) in storeHotSale.rows"
              :key="`storeHotSale-${index}`"
              :title="`${index + 1}. ${item.title}`"
              :after="`${item.count}(${hotSalePercentage(item.count, hotSaleTotalCount)})`"></f7-list-item>
          </f7-list>
        </f7-card-content>
      </f7-card>
    </template>
  </f7-page>
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters, mapActions } from 'vuex'
import * as R from 'ramda'
import NavbarCenter from '@/common/components/NavbarCenter'

export default {
  data () {
    return {
    }
  },
  async created () {
    await this.setStore(this.storeIdProp)
    this.getDefaultStatistics()
    this.getTableNumbers()
    const endDateString = moment().add(-1, 'day').format('YYYY-MM-DD') // 今天日期
    const startDateString = moment().add(-7, 'day').format('YYYY-MM-DD') // 上個月日期
    await this.getStoreHotSale({ startDateString, endDateString })
  },
  props: {
    storeIdProp: String
  },
  computed: {
    ...mapState(['store']),
    ...mapState('statisticsModule', ['todayStatistics', 'yesterdayStatistics', 'lastWeekStatistics', 'storeHotSale']),
    ...mapGetters(['storeId', 'storeName', 'storeBranch']),
    moment () { return moment },
    yesterdayStatisticsData () { return this.yesterdayStatistics ? R.head(Object.keys(this.yesterdayStatistics).map(k => this.yesterdayStatistics[k])) : null },
    lastWeekStatisticsData () { return this.lastWeekStatistics ? R.head(Object.keys(this.lastWeekStatistics).map(k => this.lastWeekStatistics[k])) : null },
    hotSaleTotalCount () {
      if (this.storeHotSale) {
        return this.storeHotSale.rows.reduce((pre, next) => {
          return Number(pre) + Number(next.count)
        }, 0)
      } else {
        return 0
      }
    }
  },
  components: {
    NavbarCenter
  },
  methods: {
    ...mapActions(['setStore', 'getTableNumbers']),
    ...mapActions('statisticsModule', ['getDefaultStatistics', 'getStoreHotSale']),
    hotSalePercentage (itemCount, hotSaleTotalCount) {
      let num = (itemCount) / hotSaleTotalCount // 計算該物品總數除上全部總數
      num = Math.round(num * 1000) / 1000 // 取至小數點後第一位
      num = Number(num * 1000) / 10
      return num + '%'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
